import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const SLIDES = [
  { src: "/img/hero-photo.jpg", mpos: "45% 20%", pan: { x: ["0%", "-3%"], scale: [1.08, 1.2] } },
  { src: "/img/cora-team.jpg", mpos: "52% 20%", pan: { x: ["-2%", "2%"], scale: [1.15, 1.05] } },
  { src: "/img/holiday-smile.jpg", mpos: "32% 40%", pan: { x: ["2%", "-2%"], scale: [1.05, 1.18] } },
  { src: "/img/cora-about.jpg", mpos: "68% 15%", pan: { x: ["0%", "2%"], scale: [1.02, 1.08] } },
  { src: "/img/slide-team-managua.jpg", mpos: "43% 30%", pan: { x: ["-3%", "0%"], scale: [1.06, 1.16] } },
  { src: "/img/slide-cora-orange.jpg", mpos: "30% 30%", pan: { x: ["2%", "-2%"], scale: [1.08, 1.18] } },
];
const DURATION = 6000;

export default function HeroSlides() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((n) => (n + 1) % SLIDES.length), DURATION);
    return () => clearInterval(t);
  }, []);
  const s = SLIDES[i];
  return (
    <div className="absolute inset-0 overflow-hidden bg-[#0B0F12]" data-testid="hero-slides">
      <AnimatePresence>
        <motion.div key={s.src} className="absolute inset-0" initial={{ opacity: 0, clipPath: "inset(0% 50% 0% 50%)" }} animate={{ opacity: 1, clipPath: "inset(0% 0% 0% 0%)" }} exit={{ opacity: 0 }} transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}>
          <img src={s.src} alt="" aria-hidden="true" className="hidden lg:block absolute inset-0 w-full h-full object-cover blur-3xl scale-125 opacity-50" />
          <motion.img src={s.src} alt="Dra. Cora Baltodano and SunCare Dental" style={{ objectPosition: s.mpos }} className="lg:hidden absolute inset-0 w-full h-full object-cover" initial={{ scale: 1.02 }} animate={{ scale: 1.12 }} transition={{ duration: DURATION / 1000 + 1.5, ease: "linear" }} data-testid={`hero-slide-mobile-${i}`} />
          <div className="lg:hidden absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/75" />
          <div className="hidden lg:block absolute inset-0 lg:py-24 lg:pl-[38%] lg:pr-10">
            <motion.img src={s.src} alt="Dra. Cora Baltodano and SunCare Dental" className="w-full h-full object-contain object-center drop-shadow-[0_30px_60px_rgba(0,0,0,0.6)]" initial={{ scale: 0.96, x: s.pan.x[0] }} animate={{ scale: 1.04, x: s.pan.x[1] }} transition={{ duration: DURATION / 1000 + 1.5, ease: "linear" }} data-testid={`hero-slide-${i}`} />
          </div>
        </motion.div>
      </AnimatePresence>
      <div className="absolute bottom-6 right-6 z-20 flex gap-2" data-testid="hero-slide-dots">
        {SLIDES.map((_, n) => (
          <button key={n} onClick={() => setI(n)} aria-label={`Slide ${n + 1}`} className="relative h-1 w-8 rounded-full bg-white/25 overflow-hidden" data-testid={`hero-dot-${n}`}>
            {n === i && <motion.span className="absolute inset-y-0 left-0 bg-[#00C9B7]" initial={{ width: 0 }} animate={{ width: "100%" }} transition={{ duration: DURATION / 1000, ease: "linear" }} />}
          </button>
        ))}
      </div>
    </div>
  );
}
